import { version } from '../../package.json';

export const environment = {
  production: false,
  apiUrl: 'https://uat-ng.sharelock.pro',
  version: version,
};
